import { render } from "./addProject_main.vue?vue&type=template&id=a2812008"
import script from "./addProject_main.vue?vue&type=script&lang=js"
export * from "./addProject_main.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__